<template>
    <div>
        <b-card
                class="relais--card"
                :class="{'br-4 block--shadow border-0 wr-header': isDesktop}"
        >
            <header class="relais--header pb-0">
                <h1 class="relais--title pb-1">
                    <i class="fas fa-child"></i>
                    Page Coach Alter Ego Digital
                </h1>
                <div class="row no-gutters relais--info">
                    <div class="col-1 px-0">
                        <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="col-11 px-0">
                        <p class="mb-0">Depuis cette page, gérez vos séances, ainsi que vos rappels ...</p>
                    </div>
                </div>
                <div class="col-12">
                    <b-form-select
                            :options="organisations"
                            @change="changeOuId($event)"
                            v-model="organisationId"
                    />
                </div>
            </header>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'CoachRoadlogInfo',
        data: () => ({
            organisationId: null,
            isDesktop: window.innerWidth > 768
        }),
        async mounted() {
            this.changeOuId(this.queryOuId)
        },
        methods: {
            updateQuery(params) {
                const route = {query: {}}
                for (const prop in params) if (params.hasOwnProperty(prop)) route.query[prop] = params[prop]
                this.$router.push(route)
            },
            changeOuId(ouId = null) {
                ouId === null ? this.updateQuery({ouId: this.organisations[0].value}) : this.updateQuery({ouId: ouId})
                this.organisationId = this.queryOuId
            },
        },
        computed: {
            organisations() {
                const organisations = []
                for (const ou of this.$store.state.base.account.ousReferent) {
                    organisations.push({
                        value: ou.id,
                        text: ou.fullName
                    })
                }
                return organisations.sort((a, b) => {
                    return b.fullName - a.fullName
                })
            },
            queryOuId() {
                return this.$route.query.ouId ?
                    parseInt(this.$route.query.ouId) :
                    this.organisations[0].value
            }
        }
    }
</script>
